
import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { LoginHeader } from "@/components/auth/LoginHeader";
import { LoginTabs } from "@/components/auth/LoginTabs";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { signIn, isAuthenticated, user, session, profile } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("email");
  const [error, setError] = useState<string | null>(null);
  
  console.log('[Login] Component mounted/updated:', {
    isAuthenticated,
    hasUser: !!user,
    hasSession: !!session,
    hasProfile: !!profile,
    currentLocation: location.pathname,
    isMobile: navigator.userAgent.includes('Mobile'),
    timestamp: new Date().toISOString()
  });
  
  const handleSubmit = async (email: string, password: string) => {
    setError(null);
    
    console.log('[Login] Form submitted, starting login process', {
      email: email,
      isMobile: navigator.userAgent.includes('Mobile'),
      currentPath: location.pathname
    });
    
    setIsLoading(true);
    
    try {
      console.log('[Login] Calling signIn...');
      await signIn(email, password);
      console.log('[Login] signIn completed successfully');
    } catch (error: unknown) {
      console.error('[Login] Login error:', error);
      const message =
        error instanceof Error
          ? error.message
          : typeof error === 'string'
            ? error
            : 'Произошла ошибка при входе';
      setError(message);
    } finally {
      setIsLoading(false);
    }
  };
  
  React.useEffect(() => {
    if (isAuthenticated && user && session && profile) {
      console.log('[Login] User already authenticated, will be redirected by AuthContext', {
        isMobile: navigator.userAgent.includes('Mobile'),
        currentPath: location.pathname
      });
    }
  }, [isAuthenticated, user, session, profile, location.pathname]);
  
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center p-4">
      <div className="w-full max-w-md">
        <Card className="shadow-lg">
          <LoginHeader />
          <CardContent>
            {error && (
              <Alert variant="destructive" className="mb-4">
                <AlertCircle className="h-4 w-4" />
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}
            
            <LoginTabs 
              activeTab={activeTab}
              onTabChange={setActiveTab}
              isLoading={isLoading}
              onSubmit={handleSubmit}
              onError={setError}
            />
          </CardContent>
          <CardFooter className="flex flex-col space-y-2 text-center">
            <div className="text-sm">
              Нет учетной записи?{" "}
              <Link to="/register" className="text-primary hover:underline">
                Зарегистрироваться
              </Link>
            </div>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
};

export default Login;
